export function getDisputeBucket(row) {
  if (row?.objectionStatus === "submitted" || row?.sent) return "submitted";
  return ["matched", "exceptioned"].includes(row?.matchStatus) ? "ready" : "notReady";
}

export function canSelectForDispute(row) {
  return getDisputeBucket(row) !== "submitted";
}

export function requiresEvidenceOverride(row) {
  return ["matched", "exceptioned"].includes(row?.matchStatus) && row?.evidenceStatus === "incomplete" && getDisputeBucket(row) !== "submitted";
}

export function requiresMatchOverride(row) {
  return ["unmatched", "ambiguous"].includes(row?.matchStatus) && getDisputeBucket(row) !== "submitted";
}

export function summarizeSelection(rows) {
  return {
    direct: rows.filter((row) => row.canSubmitDirectly || (["matched", "exceptioned"].includes(row.matchStatus) && row.evidenceStatus === "complete")).length,
    incompleteEvidence: rows.filter(requiresEvidenceOverride).length,
    unmatched: rows.filter((row) => row.matchStatus === "unmatched").length,
    ambiguous: rows.filter((row) => row.matchStatus === "ambiguous").length,
  };
}
